// src/pages/Admin/AdminUsers.jsx
import React, { useState, useEffect } from 'react';
import { usersAPI } from '../../api/users.js';
import { useToast } from '../../hooks/useToast.js';
import { Loader } from '../../components/ui/Loader/Loader.jsx';

export const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { success, error } = useToast();

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    setIsLoading(true);
    try {
      const response = await usersAPI.getAll({ limit: 100 });
      setUsers(response.data.data || []);
    } catch (err) {
      error('Не удалось загрузить пользователей');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Loader text="Загрузка пользователей..." />;
  }

  return (
    <div>
      <h2 style={{ marginBottom: '24px' }}>Пользователи</h2>

      <div style={{
        backgroundColor: 'rgb(var(--c-surface))',
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
      }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
            <thead>
              <tr style={{ backgroundColor: 'rgb(var(--c-bg))' }}>
                <th style={{ padding: '12px 16px', textAlign: 'left' }}>Имя</th>
                <th style={{ padding: '12px 16px', textAlign: 'left' }}>Email</th>
                <th style={{ padding: '12px 16px', textAlign: 'left' }}>Телефон</th>
                <th style={{ padding: '12px 16px', textAlign: 'left' }}>Роль</th>
                <th style={{ padding: '12px 16px', textAlign: 'left' }}>Статус</th>
                <th style={{ padding: '12px 16px', textAlign: 'left' }}>Дата регистрации</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id} style={{ borderTop: '1px solid rgb(var(--c-surface-2))' }}>
                  <td style={{ padding: '12px 16px', fontWeight: 500 }}>
                    {user.first_name} {user.last_name || ''}
                  </td>
                  <td style={{ padding: '12px 16px', color: 'rgb(var(--c-text-secondary))' }}>{user.email}</td>
                  <td style={{ padding: '12px 16px', color: 'rgb(var(--c-text-secondary))' }}>{user.phone || '—'}</td>
                  <td style={{ padding: '12px 16px' }}>
                    <span style={{
                      padding: '2px 10px',
                      borderRadius: '100px',
                      fontSize: '12px',
                      fontWeight: 500,
                      backgroundColor: user.role === 'admin' ? '#205CA0' :
                                    user.role === 'manager' ? '#4A6A8B' :
                                    '#28A745',
                      color: 'rgb(var(--c-on-accent))',
                    }}>
                      {user.role === 'admin' ? 'Админ' :
                       user.role === 'manager' ? 'Менеджер' :
                       'Пользователь'}
                    </span>
                  </td>
                  <td style={{ padding: '12px 16px' }}>
                    <span style={{
                      padding: '2px 10px',
                      borderRadius: '100px',
                      fontSize: '12px',
                      fontWeight: 500,
                      backgroundColor: user.is_active ? '#D4EDDA' : '#F8D7DA',
                      color: user.is_active ? '#155724' : '#721C24',
                    }}>
                      {user.is_active ? 'Активен' : 'Заблокирован'}
                    </span>
                  </td>
                  <td style={{ padding: '12px 16px', color: 'rgb(var(--c-text-secondary))' }}>
                    {new Date(user.createdAt).toLocaleDateString('ru-RU')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};